import { connect } from 'react-redux'
import { changePassword, checkPasswordStrength, closeDialog } from './password.actions'
import PasswordDialog from './Dialog'
import { StrengthT } from '../../Common/PasswordStrengthIndicator'
import { RootState } from '../app.reducer'

interface passwordIndexProps {
  open: boolean,
  passwordStrength: StrengthT,
  error: string,
  loading: boolean,
}

const mapStateToProps = ({ password }: RootState): passwordIndexProps => {
  const { dialogOpen, strength, error, loading } = password

  return {
    open: dialogOpen,
    passwordStrength: strength,
    error,
    loading,
  }
}

const mapDispatchToProps = {
  onUpdatePassword: checkPasswordStrength,
  onConfirm: changePassword,
  onClose: closeDialog,
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordDialog)
